import React from 'react'
import T from '@/components/Helpers/Translate'
import Image from 'next/image'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import { Button } from '../Button'

export const Error404 = ({
  errorLabel,
  errorDescription,
}: {
  errorLabel?: string
  errorDescription?: string
}) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  return (
    <div className="m-auto h-[80vh] max-w-[50vw]">
      <div className="m-auto flex h-full max-w-2xl flex-col items-center gap-6">
        <Image height={74} width={151} src="/icons/404.svg" alt="404" />
        <p className="text-2xl font-bold">
          <T>{errorLabel || '404_error_label'}</T>
        </p>
        <div className="max-w-sm text-center">
          <T>{errorDescription || '404_error_description'}</T>
        </div>
        <a
          className="mx-auto h-12 w-4/5"
          href={parseLinkUrlWithLocale({ url: '/products' })}
        >
          <Button
            className="mt-5 w-full rounded-full bg-secondary text-xl font-semibold"
            data-test="thank-you-continue-shopping"
          >
            <T>back_to_home</T>
          </Button>
        </a>
      </div>
    </div>
  )
}
